/*
  SMANT: laadt afbeeldingen die met snippets/smant-defer-image.liquid zijn uitgesteld
  pas zodra ze bijna in beeld komen. Zie dat bestand voor het waarom.

  De marge van 300 px zorgt dat de foto er bij normaal scrollen al staat voordat de
  bezoeker hem bereikt. Afbeeldingen die horizontaal buiten beeld staan, zoals de
  slides van een carrousel, laden pas als er naartoe geveegd wordt.
*/
(function () {
  var MARGIN = '300px 0px';

  function reveal(img) {
    if (!img.hasAttribute('data-smant-defer')) return;
    img.removeAttribute('data-smant-defer');
    var srcset = img.getAttribute('data-smant-srcset');
    var src = img.getAttribute('data-smant-src');
    if (srcset) img.srcset = srcset;
    if (src) img.src = src;
    img.removeAttribute('data-smant-srcset');
    img.removeAttribute('data-smant-src');
  }

  function each(fn) {
    Array.prototype.forEach.call(document.querySelectorAll('img[data-smant-defer]'), fn);
  }

  if (!('IntersectionObserver' in window)) {
    each(reveal);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        reveal(entry.target);
      });
    },
    { rootMargin: MARGIN }
  );

  function scan() {
    each(function (img) {
      observer.observe(img);
    });
  }

  window.smantLazyScan = scan;
  scan();

  /* Secties die de theme-editor of de Section Rendering API later inlaadt. */
  document.addEventListener('shopify:section:load', scan);
  window.addEventListener('load', scan);

  /* Bij printen bestaat er geen viewport, dus dan alles alsnog ophalen. */
  if (window.matchMedia) {
    var printQuery = window.matchMedia('print');
    if (printQuery.addEventListener) {
      printQuery.addEventListener('change', function () {
        each(reveal);
      });
    }
  }
})();
